
import React, { useEffect, useState } from "react";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle";
import "bootstrap/js/dist/popover";
import SignIn from "./Views/SignIn";
import SignUp from "./Views/SignUp";
import ForgotPassword from "./Views/ForgotPassword";
import Settings from "./Views/Settings";
import RootLayout from "./Views/RootLayout";
import ChangePassword from "./Views/Settings/ChangePassword";
import NewsFeed from "./Views/NewsFeed/NewsFeed";
import Connection from "./Views/Connections/Connection";
import GeneralSetting from "./Views/Settings/GeneralSetting";
import Profile from "./Views/Settings/Profile";
import Account from "./Views/Settings/Account";
import Auth from "./Views/Settings/Auth";
import Address from "./Views/Settings/Address";
import BlockedUser from "./Views/Settings/BlockedUser";
import PageNotifications from "./Views/Settings/PageNotifications";
import Privacy from "./Views/Settings/Privacy";
import ManageSession from "./Views/Settings/ManageSession";
import CreateCompany from "./Views/CreateCompany/CreateCompany";
import Companies from "./Views/Companies/Companies";
import People from "./Views/People/People";
import Resume from "./Views/Resume/Resume";
import PersonalProfile from "./Views/PersonalProfile/PersonalProfile";
import Notification from "./Views/Notification/Notification";
import Business from "./Views/BusinessPage/BusinessPage";
import History from "./Views/Job/History/History";
import JobSearch from "./Views/JobSearch/JobSearch";
import ManageJob from "./Views/ManageJob/ManageJob";
import JobNotification from "./Views/JobNotification/JobNotification";
import LeftSidebar from "./Views/LeftSidebar";
import Message from "./Views/Message/Message";
import TestPage from "./TestPage";
import Post from "./Views/Post/Post";
import Blogs from "./Views/Blogs/Blogs";
import BlogDetailPage from "./Views/Blogs/BlogDetailPage";
import Articles from "./Views/Articles/Articles";
import Editor from "./Views/Editor/Editor";
import UserAuth from "./Views/Auth/UserAuth";
import CustomModal from "./Views/Custome-modal/CustomModal";
import Header from "./Views/Navigation/Header";
import MyCompanies from "./Views/MyCompanies/MyCompanies";
import Skills from "./Views/PersonalProfile/Skills";
import Draft from "./Views/Post/Draft";
import JobDetails from "./Views/JobDetails/JobDetails";
import ManageResume from "./Views/ManageResume/ManageResume";
import PrivacyAndTerms from "./Views/PrivacyAndTerms/PrivacyAndTerms";
import MainPage from "./Views/PrivacyAndTerms/MainPage";
import Contact from "./Views/PrivacyAndTerms/Contact";
import About from "./Views/PrivacyAndTerms/AboutUs";
import PrivacyPolicy from "./Views/PrivacyAndTerms/PrivacyPolicy";
import TermsAndCondition from "./Views/PrivacyAndTerms/TermsAndCondition";
import UserAgreement from "./Views/PrivacyAndTerms/UserAgreement";
import ViewResume from "./Views/ManageResume/ViewResume";
import ConfirmAccount from "./Views/ConfirmAccount";
import Interview from "./Views/JobNotification/Interview";
import ScrollToTop from "./ScrollToTop";
import PrivateRoute from "./PrivateRoute"; // Import the PrivateRoute component
import useLocalStorage from "use-local-storage";
import NotFound from "./NotFound";
import AdBlockDetector from "./AdBlockDetector";
import AdblockDetector from "./AdBlockDetector";
import ModalExample from "./Views/People/ModalExample";
import NewsfeedNew from "./Views/NewsFeed/NewsfeedNew";
import ViewAllRecommendation from "./Views/NewsFeed/ViewAllRecommendation";
import HashTag from "./Views/NewsFeed/HashTag";
import HelpCenterCards from "./Views/HelpCenter/HelpCenterCards";
import ChangeEmailAddress from "./Views/Settings/ChangeEmailAddress";
import ArticleDetail from "./Views/Articles/ArticleDetail";
import ChatBox from "./Views/OuterChatBox/OuterChatBox";
import useChatStore from "./Views/OuterChatBox/useChatStore";
import "./Views/OuterChatBox/OuterChatbox.css";
import LoadingToasterBar from "./Views/LoadingToasterBar";
import NotificationsToast from "./Views/NotificationsToast";
import { HubConnectionBuilder } from "@microsoft/signalr";
import axios, { loadGA, loadGTM, RealTime_Hub } from "./API/axios";
import MsgNotificationToast from "./Views/MsgNotificationToaster";
import NewAboutus from "./Views/NewAboutus/NewAboutus";
import "./i18n"
import i18n from "./i18n";
import BlockedCompany from "./Views/Settings/BlckedCompany";
import SetPassword from "./Views/SetPassword";
import BlckedCompany from "./Views/Settings/BlckedCompany";
import SessionExpiredModal from "./SessionExpiredModal";
import SearchResult from "./Views/Navigation/SearchResult";
import {
  MESSAGE_NOTIFICATION_SOUND_URL,
  flatpickrThemeUrl,
} from "./config/staticAssets";
import useThemeStore from "./store/useThemeStore";
import { hideAppLoader } from "./utility/appLoader";
import { deferUntilIdle } from "./utility/deferNonCritical";

const App = () => {
  const [isDark, setIsDark] = useLocalStorage("isDark", false);
  const [isVideoProcessing, setIsVideoProcessing] = useState(false);
  const sessionId = localStorage.getItem("sessionId");
  const restrictedViewerTokens = localStorage.getItem("restrictedViewerToken");
  const language = localStorage.getItem("Lang");


  const [notificationData, setNoticationData] = useState({});
  const [show, setShow] = useState(false);
  const [notifiCount, setNotifiCount] = useState(0);

  const NotificationCount = async () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      langKey: language === "en" ? "" : language,
    };
    try {
      // setLoading(true);
      await axios
        .post(`General/GetUnReadNotificationCount`, data)
        .then((resData) => {

          const Response = resData.data.responseData;
          // if (notifiCount !== resData.responseData) {
          setNotifiCount(Response);
          localStorage.setItem("NotificationCountData", Response);

          // console.log("notifiCount in topnoti", Response);

          // }
        });
    } catch (error) {
      // if ((error.code === 'ERR_NETWORK' && sessionId) || (error.code === "ERR_BAD_REQUEST" && sessionId)) {
      //   setUnauthorisedModal(true)
      // }
    }
  };
  console.log("notifiCount in topnoti", notifiCount);

  useEffect(() => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => hideAppLoader());
    });
  }, []);

  useEffect(() => {
    return deferUntilIdle(() => {
      loadGA();
      loadGTM();
    }, 3000);
  }, []);

  useEffect(() => {
    const sessionId = localStorage.getItem("sessionId");
    if (!sessionId) return undefined;

    return deferUntilIdle(() => {
      NotificationCount();
    }, 2000);
  }, []);


  const [progress, setProgress] = useState(0);
  // const { chats } = useChatStore();
  useEffect(() => {
    document.body.style.backgroundColor = isDark ? "#1a1a1e" : "#F2F2F2";
  }, [isDark]);

  useEffect(() => {
    localStorage.setItem("isDark", isDark);
    const theme = isDark ? "dark" : "light";
    document.documentElement.setAttribute("data-theme", theme);
    document.documentElement.setAttribute("data-bs-theme", theme);
    document.body.classList.toggle("darkMode", isDark);
    document.body.classList.toggle("lightMode", !isDark);
    useThemeStore.getState().setIsDark(isDark);
  }, [isDark]);


  useEffect(() => {
    let linkElement;
    const darkThemeUrl = flatpickrThemeUrl("dark");
    const lightThemeUrl = flatpickrThemeUrl("light");

    if (isDark) {
      // Remove the light theme if it exists
      linkElement = document.querySelector(
        `link[href="${lightThemeUrl}"]`
      );
      if (linkElement) {
        document.head.removeChild(linkElement);
      }

      // Add the dark theme
      linkElement = document.createElement("link");
      linkElement.rel = "stylesheet";
      linkElement.href = darkThemeUrl;
      document.head.appendChild(linkElement);
    } else {
      // Remove the dark theme if it exists
      linkElement = document.querySelector(
        `link[href="${darkThemeUrl}"]`
      );
      if (linkElement) {
        document.head.removeChild(linkElement);
      }

      // Add the light theme
      linkElement = document.createElement("link");
      linkElement.rel = "stylesheet";
      linkElement.href = lightThemeUrl;
      document.head.appendChild(linkElement);
    }

    return () => {
      // Cleanup: remove the theme when the component unmounts or before adding a new one
      if (linkElement) {
        document.head.removeChild(linkElement);
      }
    };
  }, [isDark]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const guestMode = localStorage.getItem("guestMode");

    // Automatically set guestMode for new users without a token
    if (!token && !guestMode) {
      localStorage.setItem("guestMode", "true");
    }
  }, []);



  // .................... language change layout change..................................
//   useEffect(() => {
//   document.body.dir = i18n.language === "ar" ? "rtl" : "ltr";
// }, [i18n.language]);

  // .................... language change layout change..................................
//================  Message Count API ==============//

const [msgCount, setMsgCount] = useState("");

const MessagesCount = async () => {
      const data = {
        deviceType: "Web",
        sessionId: sessionId,           
         langKey: language === "en" ? "" : language,

      };
      try {
        // setLoading(true);
        await axios
          .post(`Message/AllUnreadMsgsCount`, data)
          .then((resData) => {
            // setMsgCount(resData.data.responseData);

              localStorage.setItem("MsgCountData",resData.data.responseData)

            if (msgCount !== resData.data.responseData) {
              setMsgCount(resData.data.responseData);
            }
            console.log("messagecountTotal" ,resData.data.responseData );
            
          });
      } catch (error) {
        console.log(error);
        
      }
    }; 
  
     useEffect(() => {
      const sessionId = localStorage.getItem("sessionId");
      if (!sessionId) return undefined;

      return deferUntilIdle(() => {
        MessagesCount();
      }, 2000);
    }, []);


  // ...................................
  useEffect(() => {
    let connection;
    let cancelled = false;

    const cancelDefer = deferUntilIdle(() => {
      if (cancelled) return;

      connection = new HubConnectionBuilder()
      .withUrl(RealTime_Hub, {
        skipNegotiation: false,
      })
      .withAutomaticReconnect()
      .build();

    connection
      .start()
      .then(() => {
        if (cancelled) return;
        connection.on("ReplyChat", (message) => {
          // debugger
          const userUid = localStorage.getItem("userUid");
          const loggedInUserId = localStorage.getItem("CheckNotifyId");
           const openChatUserUid = localStorage.getItem("toUserUid");
          const currentPath = window.location.pathname; // current page path

          const isChatOpen =
            currentPath.includes("/Message") && // adjust if your route differs
            ((message.senderUid === openChatUserUid &&
              message.receiverUid === userUid) ||
              (message.senderUid === userUid &&
                message.receiverUid === openChatUserUid));

          // if (message.receiverUid === userUid) {
          //   setTimeout(() => {
          //     const audio = new Audio('/wlj_msg.wav');
          //     audio.play().catch(err => console.log("Audio play failed:", err));
          //     setShow(true);
          //     setNoticationData(message);
          //   }, 3000);
          // } else {
          //   console.log("Ignored self-notification");
          // }

          if (message.receiverUid === userUid) {
            if (isChatOpen) {
              console.log("✅ Chat is open — skipping notification sound/count");
              // Optionally, you could mark as read automatically here
              // e.g., call ReadChat() if you have that API globally
            } else {
              console.log("🔔 Chat not open — show notification popup");
              // 🔹 Trigger sound + show popup after delay
              setTimeout(() => {
                const audio = new Audio(MESSAGE_NOTIFICATION_SOUND_URL);
                audio
                  .play()
                  .catch((err) => console.log("Audio play failed:", err));

                setShow(true);
                setNoticationData(message);
              }, 3000);
               MessagesCount();
            }
          } else {
            console.log("Ignored self-notification");
          }
        });
      })
      .catch((e) => console.log("Connection failed: ", e));
    }, 3500);

    return () => {
      cancelled = true;
      cancelDefer();
      if (connection) {
        connection.stop();
      }
    };
  }, []);
  // ......................................

  const [profileConfig, setProfileConfig] = useState("");

  const userConfig = async () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
    };
    try {
      await axios.post("User/GetUserConfig", data).then((resData) => {
        // console.log('profileconfig000000', resData.data.responseData);
        setProfileConfig(resData.data.responseData);
        const Response = resData.data.responseData;

      });
    } catch (error) {
      if (
        (error.code === "ERR_NETWORK" && sessionId) ||
        (error.code === "ERR_BAD_REQUEST" && sessionId)
      ) {
        // setUnauthorisedModal(true);
      }
    }
  };

  console.log("profileconfig000000", profileConfig);

  useEffect(() => {
      const sessionId = localStorage.getItem("sessionId");

  if (sessionId) {
    (async () => {  
      await Promise.all([
        userConfig()
      ]);
    })();
  } 
  }, []);


  const SyncAccount = async () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
     langKey: language === "en" ? "" : language,

    };

    try {
      const resData = await axios.post(`Feature/SyncAccountAlgoData`, data);
      // setIsLoading(false);
      const algoData = resData.data.responseData;
      // console.log("details999999999999999999", algoData);
      localStorage.setItem("engagedUsersMostEngagedPostIds", algoData.engagedUsersMostEngagedPostIds);
      localStorage.setItem("loggedInUser_EngagedUsersIDs", algoData.loggedInUser_EngagedUsersIDs);
      localStorage.setItem("peopleRecommendationsIds", algoData.peopleRecommendationsIds);

      localStorage.setItem("jobRecommendationsIds", algoData.jobRecommendationsIds);
      localStorage.setItem("companyRecommendationsIds", algoData.companyRecommendationsIds);
      localStorage.setItem("allPostsIds", algoData.allPostsIds);

      localStorage.setItem("connectedUsersIDs", algoData.connectedUsersIDs || null);
      localStorage.setItem("followedCompaniesIDs", algoData.followedCompaniesIDs || null);
      localStorage.setItem("followedUsersIDs", algoData.followedUsersIDs || null);
      localStorage.setItem("followedCompaniesPostsIds", algoData.followedCompaniesPostsIds || null);
      localStorage.setItem("ownedMostEngagedPostIds", algoData.ownedMostEngagedPostIds)
      localStorage.setItem("ownedAllPostIds", algoData.ownedAllPostIds)
      localStorage.setItem("restrictedViewerToken", algoData.restrictedViewerToken)
    } catch (error) {
      if (error.response && error.response.status === 404) {
        console.log(error.response);

      } else {
        console.error(error);
      }
    }
  };


  // useEffect(() => {
  //   // Call immediately
  //   const callSync = async () => {
  //     try {
  //       if (sessionId) {
  //         await SyncAccount();
  //       };
  //     } catch (error) {
  //       console.error("Initial SyncAccount failed:", error);
  //     }
  //   }

  //   callSync();

  //   const interval = setInterval(() => {
  //     callSync();
  //   }, 3600000); // 1 hour

  //   return () => clearInterval(interval); // Cleanup on unmount
  // }, []);

  const TokenView = async () => {
    try {
      const resData = await axios.get(`Feature/GetRestrictedViewerToken?RestrictedViewerToken=${restrictedViewerTokens}`);
     localStorage.setItem("restrictedViewerToken", resData?.data?.responseData);

    } catch (error) {
      if (error.response && error.response.status === 404) {
        console.log(error.response);

      } else {
        console.error(error);
      }
    }
  };

  useEffect(() => {
    const cancelDefer = deferUntilIdle(() => {
      TokenView();
      localStorage.setItem("TokenlastSyncTime", Date.now().toString());
    }, 2500);

    const interval = setInterval(() => {
      TokenView();
      localStorage.setItem("TokenlastSyncTime", Date.now().toString());
    }, 60 * 60 * 1000);

    return () => {
      cancelDefer();
      clearInterval(interval);
    };
  }, []);

  const router = createBrowserRouter([
    {
      path: "/",
      element: <RootLayout />,
      children: [
        {
          path: "/",
          element: <Navigate to="/NewsFeed" replace />,
        },
        {
          path: "/NewsFeedOld",
          element: (
            <PrivateRoute
              element={NewsFeed}
              isProtected={false} // Accessible in guest mode
            />
          ),
        },
        {
          path: "/NewsFeed",
          element: (
            <PrivateRoute
              // element={NewsfeedNew }
              element={() => (
                <NewsfeedNew
                  setIsVideoProcessing={setIsVideoProcessing}
                  setProgress={setProgress}
                  SyncAccount={SyncAccount}
                />
              )}
              isProtected={false} // Accessible in guest mode
            />
          ),
        },
        {
          path: "/HashTag/:Hashtag",
          element: (
            <PrivateRoute
              element={HashTag}
              isProtected={true} // Accessible in guest mode
            />
          ),
        },
        {
          path: "/Draft",
          element: (
            <PrivateRoute
              element={Draft}
              isProtected={true} // Protected route
              redirectTo="/SignIn"
            />
          ),
        },
        {
          path: "/User/:uid",
          element: (
            <PrivateRoute
              // element={PersonalProfile}
              element={() => (
                <PersonalProfile
                  setIsVideoProcessing={setIsVideoProcessing}
                  setProgress={setProgress}
                />
              )}
              isProtected={true} // Protected route
              redirectTo="/SignIn"
            />
          ),
        },
        {
          path: "/User/:uid/:tab",
          element: (
            <PrivateRoute
              // element={PersonalProfile}
              element={() => (
                <PersonalProfile
                  setIsVideoProcessing={setIsVideoProcessing}
                  setProgress={setProgress}
                />
              )}
              isProtected={true} // Protected route
              redirectTo="/SignIn"
            />
          ),
        },
        {
          path: "/User/:uid/:slug",
          element: (
            <PrivateRoute
              // element={PersonalProfile}
              element={() => (
                <PersonalProfile
                  setIsVideoProcessing={setIsVideoProcessing}
                  setProgress={setProgress}
                />
              )}
              isProtected={true} // Protected route
              redirectTo="/SignIn"
            />
          ),
        },
        {
          path: "/User/:uid/Skills",
          element: (
            <PrivateRoute
              element={Skills}
              isProtected={true} // Protected route
              redirectTo="/SignIn"
            />
          ),
        },
        {
          path: "/Connections",
          element: (
            <PrivateRoute
              element={Connection}
              isProtected={true} // Protected route
              redirectTo="/SignIn"
            />
          ),
        },
        {
          path: "/CreateCompany",
          element: (
            <PrivateRoute
              element={CreateCompany}
              isProtected={true} // Protected route
              redirectTo="/SignIn"
            />
          ),
        },
        {
          path: "/Companies",
          element: (
            <PrivateRoute
              element={Companies}
              isProtected={false} // Accessible in guest mode
              redirectTo="/SignIn"
            />
          ),
        },
        {
          path: "/MyCompanies",
          element: (
            <PrivateRoute
              element={MyCompanies}
              isProtected={true} // Protected route
              redirectTo="/SignIn"
            />
          ),
        },
        {
          path: "/People",
          element: (
            <PrivateRoute
              element={People}
              isProtected={true} // Protected route
              redirectTo="/SignIn"
            />
          ),
        },
        {
          path: "/SearchResult",
          element: (
            <PrivateRoute
              element={SearchResult}
              isProtected={true} // Protected route
              redirectTo="/SignIn"
            />
          ),
        },
        // { path: "/Notification", element: <Notification /> },
        {
          path: "/Notification",
          element: (
            <PrivateRoute
              element={() => (
                <Notification
                  notifiCount={notifiCount}
                  setNotifiCount={setNotifiCount}
                  NotificationCount={NotificationCount}
                />
              )}
              // element={Notification}
              isProtected={true} // Protected route
              redirectTo="/SignIn"
            />
          ),
        },
        {
          path: "/Company/:CompUid",
          element: (
            <PrivateRoute
              // element={Business}
              element={() => (
                <Business
                  setIsVideoProcessing={setIsVideoProcessing}
                  setProgress={setProgress}
                />
              )}
              isProtected={true} // Protected route
              redirectTo="/SignIn"
            />
          ),
        },
        {
          path: "/Company/:CompUid/:slug",
          element: (
            <PrivateRoute
              // element={Business}
              element={() => (
                <Business
                  setIsVideoProcessing={setIsVideoProcessing}
                  setProgress={setProgress}
                />
              )}
              isProtected={true} // Protected route
              redirectTo="/SignIn"
            />
          ),
        },
        {
          path: "/ManageJob",
          element: (
            <PrivateRoute
              element={ManageJob}
              isProtected={true} // Protected route
              redirectTo="/SignIn"
            />
          ),
        },
        {
          path: "/settings",
          element: (
            <PrivateRoute
              element={Settings}
              isProtected={true} // Protected route
              redirectTo="/SignIn"
              setProfileConfig={setProfileConfig}
              profileConfig={profileConfig} 
            />
          ),
          children: [
            { path: "changePassword", element: <ChangePassword /> },
            { path: "general", element: <GeneralSetting /> },
            { path: "profile", element: <Profile /> },
            { path: "account", element: <Account /> },
            { path: "2fAuth", element: <Auth 
                                          setProfileConfig={setProfileConfig}
                                          profileConfig={profileConfig} 
                                        /> },
            { path: "changeEmailAddress", element: <ChangeEmailAddress /> },
            { path: "address", element: <Address /> },
            { path: "blockedUser", element: <BlockedUser /> },
            { path: "blockedCompany", element: <BlckedCompany /> },
            { path: "pageNotification", element: <PageNotifications /> },
            { path: "privacy", element: <Privacy /> },
            { path: "manageSessions", element: <ManageSession /> },
          ],
        },
      ],
    },

    {
      path: "/",
      element: <LeftSidebar
        setProfileConfig={setProfileConfig}
        profileConfig={profileConfig}
      />,
      children: [
        {
          path: "/JobApplications",
          element: (
            <PrivateRoute
              element={JobNotification}
              isProtected={true} // Protected route
              redirectTo="/SignIn"
            />
          ),
        },
        {
          path: "/CreateCompany",
          element: (
            <PrivateRoute
              element={CreateCompany}
              isProtected={true} // Protected route
              redirectTo="/SignIn"
            />
          ),
        },
        {
          path: "/Interview",
          element: (
            <PrivateRoute
              element={Interview}
              isProtected={true} // Protected route
              redirectTo="/SignIn"
            />
          ),
        },
        {
          path: "/Message/:UserId",
          element: (
            <PrivateRoute
              // element={Message}
              element={() => (
                <Message
                  setShowT={setShow}
                  setNoticationDataT={setNoticationData}
                  showT={show}
                  notificationData={notificationData}
                  MessagesCount={MessagesCount}
                />
              )}
              isProtected={true}
              redirectTo="/SignIn"
            />
          ),
        },
        {
          path: "/ManageResume/:UserId",
          element: (
            <PrivateRoute
              element={ManageResume}
              isProtected={true} // Protected route
              redirectTo="/SignIn"
            />
          ),
        },
        {
          path: "/ManageJobs",
          element: (
            <>
              <PrivateRoute
                element={History}
                isProtected={true} // Protected route
                redirectTo="/SignIn"
              />
            </>
          ),
        },

        {
          path: "/Post/:PostId", element: <Post
            setIsVideoProcessing={setIsVideoProcessing}
            setProgress={setProgress} />
        },
        {
          path: "/Post/:PostId/:slug", element: <Post
            setIsVideoProcessing={setIsVideoProcessing}
            setProgress={setProgress} />
        },

        { path: "/Article/:PostId/:slug", element: <ArticleDetail /> },
      ],
    },
    { path: "/Resume", element: <Resume /> },
    {
      path: "/SignIn",
      element: (
        <PrivateRoute
          element={SignIn}
          isProtected={false} // Only accessible if not logged in or in guest mode
          redirectTo="/"
        />
        // <PrivateRoute
        //   element={<SignIn />}
        //   redirectTo="/"
        // />
      ),
    },
    {
      path: "/SignUp",
      element: (
        <PrivateRoute element={SignUp} isProtected={false} redirectTo="/" />
      ),
    },
    { path: "/ForgotPassword", element: <ForgotPassword /> },
    { path: "/ConfirmAccount", element: <ConfirmAccount /> },
    { path: "/SetPassword", element: <SetPassword /> },
    // {
    //   path: "/ManageJobs",
    //   element: (
    //     <>
    //       <Header
    //         isDark={isDark} setIsDark={setIsDark}
    //         notifiCount={notifiCount}
    //         setNotifiCount={setNotifiCount}
    //         NotificationCount={NotificationCount} 
    //         MessagesCount={MessagesCount}
    //         />
    //       {/* <History /> */}
    //       <PrivateRoute
    //         element={History}
    //         isProtected={true} // Protected route
    //         redirectTo="/SignIn"
    //       />
    //     </>
    //   ),
    // },
    {
      path: "/SearchJob",
      element: (
        <>
          <Header isDark={isDark} setIsDark={setIsDark}
            notifiCount={notifiCount}
            setNotifiCount={setNotifiCount}
            NotificationCount={NotificationCount} MessagesCount={MessagesCount}/>

          <PrivateRoute
            element={JobSearch}
            isProtected={true}
            redirectTo="/SignIn"
          />
        </>
      ),
    },
    {
      path: "/JobDetail/:JobId",
      element: (
        <>
          <Header isDark={isDark} setIsDark={setIsDark}
            notifiCount={notifiCount}
            setNotifiCount={setNotifiCount}
            NotificationCount={NotificationCount} MessagesCount={MessagesCount}/>
          <JobDetails />
        </>
      ),
    },
    {
      path: "/JobDetail/:JobId/:slug",
      element: (
        <>
          <Header isDark={isDark} setIsDark={setIsDark}
            notifiCount={notifiCount}
            setNotifiCount={setNotifiCount}
            NotificationCount={NotificationCount} MessagesCount={MessagesCount}/>
          <JobDetails />
        </>
      ),
    },

    {
      path: "/Resume/:UserId",
      element: (
        <>
          <ViewResume />
        </>
      ),
    },
    {
      path: "/about",
      element: (
        <>
          <About />
        </>
      ),
    },
    {
      path: "/aboutus",
      element: (
        <>
          <About />
        </>
      ),
    },
    {
      path: "/Newaboutus",
      element: (
        <>
          <NewAboutus />
        </>
      ),
    },
    {
      path: "/privacyPolicy",
      element: (
        <>
          <PrivacyPolicy />
        </>
      ),
    },
    {
      path: "/termsAndCondition",
      element: (
        <>
          <TermsAndCondition />
        </>
      ),
    },
    {
      path: "/userAgreement",
      element: (
        <>
          <UserAgreement />
        </>
      ),
    },
    {
      path: "/modal",
      element: (
        <>
          <ModalExample />
        </>
      ),
    },
    {
      path: "/contact",
      element: (
        <>
          <Contact />
        </>
      ),
    },
    {
      path: "/privacyAndTerms",
      element: (
        <>
          <PrivacyAndTerms />
        </>
      ),
    },
    { path: "/TestPage", element: <TestPage /> },
    {
      path: "/HelpCenter",
      element: (
        <>
          <Header isDark={isDark} setIsDark={setIsDark}
            notifiCount={notifiCount}
            setNotifiCount={setNotifiCount}
            NotificationCount={NotificationCount} MessagesCount={MessagesCount}/>
          <HelpCenterCards isDark={isDark} />
        </>
      ),
    },
    {
      path: "/Blogs",
      element: (
        <>
          <Header isDark={isDark} setIsDark={setIsDark}
            notifiCount={notifiCount}
            setNotifiCount={setNotifiCount}
            NotificationCount={NotificationCount} MessagesCount={MessagesCount}/>
          <Blogs />
        </>
      ),
    },
    {
      path: "/Blogs/:slug",
      element: (
        <>
          <Header isDark={isDark} setIsDark={setIsDark}
            notifiCount={notifiCount}
            setNotifiCount={setNotifiCount}
            NotificationCount={NotificationCount} MessagesCount={MessagesCount}/>
          <BlogDetailPage />
        </>
      ),
    },
    {
      path: "/Blogs/category/:slug",
      element: (
        <>
          <Header isDark={isDark} setIsDark={setIsDark}
            notifiCount={notifiCount}
            setNotifiCount={setNotifiCount}
            NotificationCount={NotificationCount} MessagesCount={MessagesCount}/>
          <Blogs />
        </>
      ),
    },
    {
      path: "/MainPage",
      element: (
        <>
          <MainPage />
        </>
      ),
    },
    {
      path: "/view-all-Recommendation",
      element: (
        <>
          <ViewAllRecommendation />
        </>
      ),
    },
    { path: "/Articles", element: <Articles /> },

    { path: "/Editor", element: <Editor /> },
    { path: "/UserAuth", element: <UserAuth /> },
    { path: "/CustomModal", element: <CustomModal /> },
    {
      path: "*",
      element: <NotFound />,
    },
  ]);

  // Check if root element exists
  useEffect(() => {
    const rootElement = document.getElementById('root');
    if (!rootElement) {
      console.error('Root element not found! Creating fallback UI.');
      document.body.innerHTML = '<div id="root"></div>';
      window.location.reload();
    }
  }, []);

  return (
    <>
      {/* <ScrollToTop /> */}

      <div data-theme={isDark ? "dark" : "light"}>
        <RouterProvider router={router} />
        <AdblockDetector />
        {/* {
          chats && (
            <div data-theme={isDark ? "dark" : "light"} className="chat-container">
              {chats.map(user => (
                <ChatBox key={user.userUid} user={user} />
              ))}
            </div>
          )
        } */}
      </div>

      {isVideoProcessing && (
        <LoadingToasterBar
          progress={progress}
          onClose={() => setIsVideoProcessing(false)}
        />
      )}

      <MsgNotificationToast
        id={Date.now()}
        show={show}
        data={notificationData}
        onClose={() => setShow(false)}
      />
      
      <SessionExpiredModal />
    </>
    // <RouterProvider router={router}>
    //   <ScrollToTop /> {/* Place it here inside the RouterProvider */}
    //   <div data-theme={isDark ? "dark" : "light"}>
    //     <RouterProvider router={router} />
    //   </div>
    // </RouterProvider>

  );
};

export default App;
